import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { connect, useSelector, useDispatch } from 'react-redux';
import ScaleLoader from 'react-spinners/ScaleLoader';
import Home from './Home/Home';
import {Landing} from './landing/Landing';
import Navbar from './header/Navbar';
import Products from './Products/Products';
import Contact from './Contact/Contact';
import { Footer } from './footer/FooterTemplate';
import ProductDetails from './Products/Details';
import ShoppingCart from './Cart/ShoppingCart';
import Login from './Login/Login';
import Forgot from './Login/Forgot';
import Profile from './Profile/Profile';
import Terms from './TermsAndPolicy/Terms';
import Policy from './TermsAndPolicy/Policy';

import '../fonts/Optician-Sans/Optiker-K.css';
import '../fonts/inter/inter.css';

import BackofficeOffers from './BackOffice/Offers';
import BackofficeAnnouncements from './BackOffice/Announcements';
import BackOfficeOrders from './BackOffice/Orders';
import BackOfficeNavigationMenu from './BackOffice/NavigationMenu';
import BackOfficeCustomers from './BackOffice/Customers';
import BackOfficeProducts from './BackOffice/Products';
import BackOfficeReviews from './BackOffice/Reviews';
import BackofficeLogin from './BackOffice/Login';
import About from './About/About';

import { getCustomerCart, getCustomerProfile, getNotifications, adminToken } from '../network';
import { setUser } from '../redux/actions/UserActions';
import { setCart } from '../redux/actions/CartActions';

import ProtectedRoute from '../hocs/ProtectedRoute';
import ProtectedAdminRoute from '../hocs/ProtectedAdminRoute';

import OrderConfirmation from './Cart/OrderConfirmation';
import CashierView, { OrderLayer, OrderDone } from './Kiosk/CashierView';
import LoadingComponent from './shared/LoadingComponent';
import ProductsLanding from './Products/Landing';
import NotFound from './NotFound';
import { subscribeToOrders } from '../notification/index';
import Notification from './Notification/Notification';
import { newOrderNotificationAction } from '../redux/actions/NotificationActions';
import UIFX from 'uifx';
import neworderfx from '../audio/neworder.mp3';
import BackofficeNotifications from './BackOffice/Notifications';
import ComingSoon from './ComingSoon/ComingSoon';
import ReviewOverlayComponent from './shared/ReviewOverlayComponent';
import CovidBanner from './CovidBanner/CovidBanner';



const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: auto;
	height: 100%;
	min-height: 100vh;
	overflow-x: hidden;
	@media only screen and (max-width: 900px) {
	}
	@media only screen and (max-width: 414px) {
	}
`;
const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: calc(100vh - (var(--header-height)+var(--footer-height)));
	width: 100%;
	align-items: center;
    justify-content: center;
    /* overflow: auto; */

	@media only screen and (max-width: 1100px) {
        width: 60rem;
	}
	@media only screen and (max-width: 800px) {
        width: 40rem;
    }
    @media only screen and (max-width: 500px) {
        width: 22rem;
    }
`;
const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	width:100%;
	max-width: ${(props) =>
        props.containerWidth ? props.containerWidth : '73.75rem'};
	height: 100%;
	transition: max-width 0.3s ease-in;

    @media only screen and (max-width: 500px) {
        width: 90vw;
        
    }

    .watermark{
        opacity: 0.4;
        z-index: -1;
        background-image: url('/page-decor/logo-watermark.svg');
        /* background-color: black; */
        background-position: center;
        background-repeat: no-repeat;
        position: fixed;
        right: 10%;
        width: 90vw;
        height: 75vh;
    }
`;
const ContentWrapperBackOffice = styled.div`
	display: flex;
	width: 100%;
	height: 100vh; // desperation
	overflow: hidden; // desperation

	background: var(--color-gray-200);
`;
const SpinnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height:100%;
`;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  justify-self:center;
  z-index:1;
`;

const SwitchContainer = styled.div`
    width: var(--content-max-width);
    height: calc((var(--footer-height) - var(--header-height)));
    background: var(--color-white);
    opacity: ${(props) =>
        props.ContainerOpacity ? 1 : 0};
`;

function ConsumerContentWrapper({ routes, header, loading }) {
    const location = useLocation();
    const [width, setWidth] = useState('');
    // const [display,setDisplay] = useState(disableLoading);
    const [opacity, setOpacity] = useState(0);

    let router = [];

    useEffect(() => {
        breakpoint();
    }, [location.pathname]);

    // const checkRender = () =>{
    //     if(num === 1){
    //         setDisplay('none');
    //     }
    // }

    const breakpoint = () => {
        switch (location.pathname) {
            case '/contact':
                setWidth('64rem');
                break;
            case '/landing':
                setWidth('64rem');
                break;
            case '/about':
                setWidth('64rem');
                break;
            case '/cashier':
                setWidth('45rem');
                break;
            case '/products':
                setWidth('72rem');
                break;
            case '/home':
                setWidth('64rem');
                break;
            case '/login':
                setWidth('64rem');
                break;
            case '/profile':
                setWidth('72rem');
                break;
            // case '/kiosk':
            //     setWidth('100vw');
            //     break;
        }
    };

    return (
        <>
            <PageWrapper>
                <CovidBanner/>
                <Navbar name={header} />
                {/*{location.pathname !== '/kiosk' && <Navbar name={header}/>}*/}

                <ContentWrapper>

                    <ContentContainer containerWidth={width}>
                        <div className="watermark"></div>

                        <Switch>
                            {routes.map((route, index) => {

                                return route.isProtected ? (
                                    <ProtectedRoute
                                        key={`ConsumerRoute_${index}`}
                                        path={route.path}
                                        exact
                                        component={route.render}
                                    />

                                ) : (
                                        <Route
                                            key={`ConsumerRoute_${index}`}
                                            path={route.path}
                                            exact
                                            component={route.render}
                                        />
                                    );
                            })}
                        </Switch>


                    </ContentContainer>

                </ContentWrapper>
                <Footer />
                {/*{location.pathname !== '/kiosk' && <Footer/>}*/}
            </PageWrapper>
        </>
    );
}

function BackOfficeContentWrapper({ routes, getNotifications, notification, values, setConfirm, setCancel, cancel, confirm }) {

    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();


    const soundFX = new UIFX(
        neworderfx,
    )


    //Handling Socket events
    //Callback function passed to subscribeToOrder
    const receivedNotif = (customer_name) => {
        // console.log(`Received order from ${customer_name}`);
        soundFX.play(0.2);
        getNotifications();
        //dispatch(newOrderNotificationAction({customer_name}));
    };
    useEffect(() => {
        getNotifications();
        subscribeToOrders(receivedNotif, auth);
    }, [auth.token]);


    const location = useLocation();
    const [width, setWidth] = useState('');



    const BreakPoint = () => {
        switch (location.pathname) {
            case '/backoffice/login':
                setWidth('64rem');
                break;
        }
    };
    useEffect(() => {
        BreakPoint();
    }, [location.pathname]);
    return (
        <div>
            
            {/* <Notification /> */}
            <PageWrapper>
       
                <ContentWrapperBackOffice>
                    {!location.pathname.includes('login') && <BackOfficeNavigationMenu />}

                    {location.pathname.includes('login') && <ContentWrapper>
                        <ContentContainer containerWidth={width}>
                            <Switch>
                                <ProtectedAdminRoute
                                    path={'/backoffice/login'}
                                    component={() => <BackofficeLogin />}
                                    exact
                                />
                            </Switch>
                        </ContentContainer>
                    </ContentWrapper>}

                    <Switch>
                        {routes.map((route, index) => (
                            <ProtectedAdminRoute
                                key={`BackOfficeRoute_${index}`}
                                path={route.path}
                                component={route.render}
                                exact
                            />
                        ))}
                    </Switch>
                </ContentWrapperBackOffice>
            </PageWrapper>
        </div>
    );
}

function App({ auth, user, setUser, setCart, loading, newOrderNotificationAction }) {
    const location = useLocation();
    const [header, setHeader] = useState('Sign In');
    const [values, setValues] = useState({});
    const [cancel, setCancel] = useState();
    const [confirm, setConfirm] = useState();

    useEffect(() => {
        
        const retrieveUserInfo = async () => {
            if (auth.customer_id && auth.token) {
                try {
                    const user = await getCustomerProfile(
                        auth.customer_id,
                        auth.token,
                    );
                    const cart = await getCustomerCart(
                        auth.customer_id,
                        auth.token,
                    );

                    setUser(user);
                    setCart(cart);
                } catch (error) {
                    console.error(error);
                }
            }
        };
        retrieveUserInfo();
    }, [auth]);

    const showNotifications = () => {
        getNotifications(adminToken)
            .then(result => {
                setValues(result.results);
                newOrderNotificationAction(result.results);

            })
            .catch(error => console.error(error));

    };



    const consumerRoutes = [
        {
            path: '/home',
            render: () => <Home />,
        },
        {
            path: '/products',
            render: () => <Products />,
        },
        {
            path: '/products-landing',
            render: () => <ProductsLanding />,
        },
        {
            path: '/products/:id',
            render: () => <ProductDetails />,
        },
        {
            path: '/forgot-password',
            render: () => <Forgot />,
            isProtected: true,
        },
        {
            path: '/contact',
            render: () => <Contact />,
        },
        {
            path: '/cart',
            render: () => <ShoppingCart />,
        },
        {
            path: '/about',
            render: () => <About />,
        },
        {
            path: '/landing',
            render: () => <Landing />,
        },
        {
            path: '/terms-of-use',
            render: () => <Terms />,
        },
        {
            path: '/privacy-policy',
            render: () => <Policy />,
        },
        {
            path: '/kiosk',
            render: () => <CashierView />,
        },
        {
            path: '/kiosk/:id',
            render: () => <OrderLayer />,
        },
        {
            path: '/cashier/:id',
            render: () => <OrderDone />,
        },
        {
            path: '/order-confirmation/:id',
            render: () => <OrderConfirmation />,
        },
        {
            path: '/login',
            render: () => <Login />,
            isProtected: true,
        },
        {
            path: '/profile',
            render: () => <Profile />,
            isProtected: true,
        },
        {
            path: '/coming-soon',
            render: () => <ComingSoon />,
        },
        {
            path: '/',
            // render: () => <Redirect to="/landing" />,
            render: () => <Redirect to="/coming-soon" />,
        },
        {
            path: '*',
            render: () => <NotFound />
        }
    ];

    const backofficeRoutes = [
        {
            path: '/backoffice/orders',
            render: () => <BackOfficeOrders />,
        },
        {
            path: '/backoffice/customers',
            render: () => <BackOfficeCustomers />,
        },
        {
            path: '/backoffice/products',
            render: () => <BackOfficeProducts />,
        },
        {
            path: '/backoffice/notifications',
            render: () => <BackofficeNotifications />,
        },
        {
            path: '/backoffice/offers',
            render: () => <BackofficeOffers />,
        },
        {
            path: '/backoffice/announcements',
            render: () => <BackofficeAnnouncements />,
        },
        {
        	path: "/backoffice/reviews",
        	render: () => <BackOfficeReviews/>,
        },
        {
            path: '/backoffice',
            render: () => <Redirect to="/backoffice/orders" />,
        }
    ];

    return (
        <>
            {location.pathname.includes('backoffice') ? (
                <BackOfficeContentWrapper routes={backofficeRoutes} getNotifications={showNotifications} values={values}
                  />
            ) : (
                    <ConsumerContentWrapper
                        routes={consumerRoutes}
                        header={header}
                        loading={loading}
                    />
                )}
        </>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
    user: state.user,
    loading: state.loading,
    notification: state.notification
});

const mapDispatchToProps = {
    setUser,
    setCart,
    newOrderNotificationAction
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
